<script setup>
import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { API, HOST_TULUM } from '@/utils/http'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { MonthlyPlanetscope, QuarterlyPlanetscope } from '@/components/layers'
import { TriangleAlert } from 'lucide-vue-next'

const props = defineProps({
  map: {
    type: Object,
    required: true
  },
  beforeId: {
    type: String,
    required: true
  },
  layerId: {
    type: String,
    required: true
  },
  groupId: {
    type: String,
    required: true
  },
  orgId: {
    type: Number,
    required: true
  },
  options: {
    type: Object,
    required: false,
    default: () => ({})
  }
})

const emit = defineEmits(['isLoaded'])
const store = useStore()
const isLoaded = ref(false)
const isEmpty = ref(false)
const mosaics = ref({
  monthly: [],
  quarterly: []
})

const activeTab = ref('monthly')

onMounted(async () => {
  // Check access first
  // if (!hasPlanetscopeAccess.value) {
  //   isEmpty.value = true
  //   isLoaded.value = true
  //   emit('isLoaded', isLoaded.value)
  //   return
  // }

  try {
    const response = await API({
      method: 'GET',
      url: `${HOST_TULUM}/tiles/planetscope/${props.orgId}`
    })

    if (!response.data) return
    mosaics.value = response.data

    if (mosaics.value.monthly.length === 0 && mosaics.value.quarterly.length === 0) {
      isEmpty.value = true
      return
    }

    mosaics.value.monthly.reverse()
    mosaics.value.quarterly.reverse()

    isLoaded.value = true
    emit('isLoaded', isLoaded.value)
  } catch (error) {
    console.error('Failed to load PlanetScope mosaics:', error)
    isEmpty.value = true
    isLoaded.value = true
    emit('isLoaded', isLoaded.value)
  }
})
</script>

<template>
  <div v-if="isLoaded" class="mb-2 mr-2 mt-2 rounded">
    <Tabs v-model="activeTab" class="w-full" v-if="mosaics?.monthly?.length || mosaics?.quarterly?.length">
      <TabsList class="grid w-full grid-cols-2">
        <TabsTrigger value="monthly">
          <div class="flex items-center">
            <span>Monthly</span>
          </div>
        </TabsTrigger>

        <TabsTrigger value="quarterly">
          <div class="flex items-center">
            <span>Quarterly</span>
          </div>
        </TabsTrigger>
      </TabsList>

      <TabsContent value="monthly" forceMount>
        <MonthlyPlanetscope
          :map="map"
          :mosaics="mosaics.monthly"
          :before-id="beforeId"
          :group-id="groupId"
          :org-id="orgId"
          :layer-id="layerId"
          :options="options"
          v-if="mosaics.monthly.length && activeTab === 'monthly'"
        />
      </TabsContent>

      <TabsContent value="quarterly" forceMount :hidden="activeTab !== 'quarterly'">
        <QuarterlyPlanetscope
          :map="map"
          :mosaics="mosaics.quarterly"
          :before-id="beforeId"
          :group-id="groupId"
          :org-id="orgId"
          :layer-id="layerId"
          :options="options"
          v-if="mosaics.quarterly.length && activeTab === 'quarterly'"
        />
      </TabsContent>
    </Tabs>

    <!-- <div v-if="isEmpty">
      <div v-if="!hasPlanetscopeAccess" class="p-4 bg-amber-50 border border-amber-200 rounded-lg">
        <div class="flex items-center text-amber-700">
          <TriangleAlert class="w-5 h-5 mr-2 flex-shrink-0" />
          <div>
            <p class="font-medium">PlanetScope Access Required</p>
            <p class="text-sm text-amber-600 mt-1">
              You don't have access to Planet API. Please contact your administrator to enable PlanetScope access.
            </p>
          </div>
        </div>
      </div>
      <p v-else class="text-center text-gray-500">No PlanetScope mosaics available</p>
    </div> -->
  </div>
</template>
